import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { DataCollectionRequestInfo } from "../../../../api/types/dataCollectionTypes";
import type { ObjectAccessCategory } from "../../../../api/types/objectTypes";

interface Props {
  hasPermissionsToManage: boolean;
  categories: ObjectAccessCategory[];
  onPublish: (dataRequest: DataCollectionRequestInfo) => void;
  onDelete: (dataRequest: DataCollectionRequestInfo) => void;
}

const DataRequestsListActionsContext = createContext<Props | undefined>(undefined);

export const DataRequestsListActionsContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <DataRequestsListActionsContext value={contextValue}>{children}</DataRequestsListActionsContext>
);

export default DataRequestsListActionsContext;
